import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { JsonApiWrap } from '../../shared/models/JsonApiWrap';
import { IntegrationService } from '../../shared/services/integration.service';
import { HeadersService } from '../../shared/utilities/HeadersService';
import { LetterOfAuthorizationRequest } from '../models/pdf/LetterOfAuthorizationRequest';
import { LetterOfAuthorizationResponse } from '../models/pdf/LetterOfAuthorizationResponse';

@Injectable({
  providedIn: 'root',
})
export class LetterOfAuthorizationService {
  mmExperienceApiPath: string = 'api/ria.MoneyMovementExperience';

  constructor(
    private http: HttpClient,
    private headersService: HeadersService,
    private integrationService: IntegrationService
  ) {}

  callLetterOfAuthorization(
    requestData: LetterOfAuthorizationRequest
  ): Observable<LetterOfAuthorizationResponse> {
    let serviceUrl =
      this.integrationService.JfkEnv.BaseUrl +
      this.mmExperienceApiPath +
      '/v1/LettersOfAuthorization';
    let requestBody: JsonApiWrap<LetterOfAuthorizationRequest> = {
      data: {
        attributes: requestData,
        type: 'letters-of-authorization',
        id: '',
      },
    };
    let headers =
      this.headersService.createHeadersWithJsonApiContentSharedToken('1');
    return this.http
      .post<JsonApiWrap<LetterOfAuthorizationResponse>>(
        serviceUrl,
        requestBody,
        { headers }
      )
      .pipe(map((res) => res.data.attributes));
  }
}
